module.exports = __webpack_public_path__ + "static/media/logo_esn_invert_en.2f1d7690.svg";